import { apiRequest, fetchWithAuth } from '../utils/api';
import { getApiEndpoint } from '../config/api';
import { getAuthHeader } from '../utils/auth';

export const getContractorTasks = async (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  const url = qs ? `/api/contractor/tasks?${qs}` : '/api/contractor/tasks';
  const response = await apiRequest(url);
  return response?.tasks || [];
};

export const updateContractorTaskStatus = async (taskId, status, notes) => {
  return apiRequest(`/api/contractor/tasks/${taskId}/status`, {
    method: 'PATCH',
    body: JSON.stringify({ status, notes })
  });
};

export const getContractorInspections = async () => {
  const response = await apiRequest('/api/contractor/inspections');
  return response?.inspections || [];
};

export const updateContractorInspectionStatus = async (inspectionId, status) => {
  return apiRequest(`/api/contractor/inspections/${inspectionId}/status`, {
    method: 'PATCH',
    body: JSON.stringify({ status })
  });
};

export const submitContractorInspectionReport = async (inspectionId, payload) => {
  return apiRequest(`/api/contractor/inspections/${inspectionId}/report`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

export const uploadInspectionPhotos = async (inspectionId, files = []) => {
  const formData = new FormData();
  files.forEach((file) => formData.append('photos', file));
  const response = await fetchWithAuth(getApiEndpoint(`/api/contractor/inspections/${inspectionId}/report`), {
    method: 'POST',
    headers: { ...getAuthHeader() },
    body: formData
  });
  if (!response) return null;
  const json = await response.json();
  if (!response.ok) {
    throw new Error(json?.message || 'Failed to upload inspection photos');
  }
  return json;
};

export const getContractorReports = async () => {
  const response = await apiRequest('/api/contractor/reports');
  return response?.reports || [];
};

export const generateContractorReport = async (payload) => {
  return apiRequest('/api/contractor/reports/generate', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

export const uploadContractorReportFiles = async ({ propertyId, title, type, files = [] }) => {
  const formData = new FormData();
  formData.append('propertyId', propertyId);
  if (title) formData.append('title', title);
  if (type) formData.append('type', type);
  files.forEach((file) => formData.append('files', file));

  const response = await fetchWithAuth(getApiEndpoint('/api/contractor/reports/upload'), {
    method: 'POST',
    headers: { ...getAuthHeader() },
    body: formData
  });
  if (!response) return null;
  const json = await response.json();
  if (!response.ok) {
    throw new Error(json?.message || 'Failed to upload report files');
  }
  return json;
};

export const archiveContractorReport = async (reportId) => {
  return apiRequest(`/api/contractor/reports/${reportId}/archive`, { method: 'POST' });
};

export const getContractorReportDownloadUrl = (reportId) => {
  return getApiEndpoint(`/api/contractor/reports/${reportId}/download`);
};

export const shareContractorReport = async (reportId) => {
  return apiRequest(`/api/contractor/reports/${reportId}/share`, { method: 'POST' });
};
